import { render, staticRenderFns } from "./VControls.vue?vue&type=template&id=54ac5eb0&"
import script from "./VControls.vue?vue&type=script&lang=ts&"
export * from "./VControls.vue?vue&type=script&lang=ts&"
import style0 from "./VControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports